export default __webpack_public_path__ + "faf894c93331b566de8e6993588dff98.png";